import { render } from "./AdminDocuments.vue?vue&type=template&id=3ddc5186"
import script from "./AdminDocuments.vue?vue&type=script&lang=js"
export * from "./AdminDocuments.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__